export default __webpack_public_path__ + "static/media/1571.0a40c214.png";